// authReducer.js

import {LOGIN_SUCCESS, LOGOUT_SUCCESS, SET_ERROR, UPDATE_USER_SETTINGS} from "../constants/login.constant";

const initialState = {
    user: null,
    user_settings: null,
    error: null,
};

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_SUCCESS:
            return {
                ...state,
                user: action.user,
                user_settings: action.user_settings,
                error: null,
            };
        case LOGOUT_SUCCESS:
            return {
                ...state,
                user: null,
                user_settings: null,
                error: null,
            };
        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case UPDATE_USER_SETTINGS:
            return {
                ...state,
                user_settings: action.payload,
            };
        default:
            return state;
    }
};

export default authReducer;
